import React from 'react'
import ArticleContainer from '../ArticleContainer'


const SubMenu = ({subMenu}) => {
    let content = subMenu?.ContentRuleZone?.[0];
    let type = content?.['@type'];
    let templateType = content?.templateType;
    let ruleTypeContentId = content?.contentId;
    let contentWidth =''
			if(content.attributes){
				contentWidth = content.attributes.articleContainerRendering?content.attributes.articleContainerRendering:"";
			}
   
  return (
    <span className={`content-rule plugin-rule-folder ${contentWidth}`}>
    {
        type === "ArticleContainer" ? <ArticleContainer containerObject={content} contentId={ruleTypeContentId} dataZone={type} templateName={type}  />:<></>
    }
    </span>
  )
}

export default SubMenu